import React, { useState } from "react";
import SalaryReportWithNamesMaster from "../../components/payslipDetails/SalarySheet"; 
import PaymentSlipReport from "../../components/payslipDetails/PaymentSlipReport";
import HeadwiseSalary from "../../components/payslipDetails/HeadwiseSalaryReport";

export default function SalaryReportsPage() {
  const [reportType, setReportType] = useState(""); // "salarySheet" | "paymentSlip | "headWise"
  const [month, setMonth] = useState(new Date().getMonth() + 1);
  const [year, setYear] = useState(new Date().getFullYear());

  return (
    <div className="container mt-3" >
    {/* <div className="container-fluid mt-3" style={{ overflowX: "auto" }}> */}

      <h2>Salary Reports</h2>

      {/* Month & Year Selector */}
      <div className="row mb-3">
        {/* Report Type Dropdown */}
        <div className="col-4">
          <label>Select Report</label>
          <select value={reportType} onChange={(e) => setReportType(e.target.value)} className="form-select form-select-sm">
            <option value="">-- Select Report --</option>
            <option value="salarySheet">Salary Sheet</option>
            <option value="paymentSlip">Payment Slip</option>
            <option value="headWise">HeadWise Sheet</option>
          </select>
        </div>
        <div className="col-2">
          <label>Month</label>
          <input type="number" placeholder="1-12" value={month} min="1" max="12"
            onChange={(e) => {
              let value = e.target.value;
              if (value === "" || (value >= 1 && value <= 12))
                setMonth(value);
            }}
            className="form-control form-control-sm"
          />
        </div>

        <div className="col-2">
          <label>Year</label>
          <input type="number" value={year}
            onChange={(e) => {
              let value = e.target.value;
              if (value.length <= 4) setYear(value);
            }}
            className="form-control form-control-sm"
          />
        </div>
      </div>
      <hr />
      {/* Dynamic Report Renderer */}
      <div className="mt-3">
        {reportType === "salarySheet" && (
          <SalaryReportWithNamesMaster reportName={reportType} month={month} year={year} />
        )}
        {reportType === "paymentSlip" && (
          <PaymentSlipReport reportName={reportType} month={month} year={year} />
        )}
        {reportType === "headWise" && (
            <HeadwiseSalary reportName={reportType} month={month} year={year} />
        )}
      </div>
    </div>
  );
}




// import React, { useState } from "react";
// import SalaryReportWithNamesMaster from "../../components/payslipDetails/SalarySheet"; 
// import PaymentSlipReport from "../../components/payslipDetails/PaymentSlipReport";
// import HeadwiseSalary from "../../components/payslipDetails/HeadwiseSalaryReport";

// export default function SalaryReportsPage() {
//   const [reportType, setReportType] = useState("");
//   const [month, setMonth] = useState(new Date().getMonth() + 1);
//   const [year, setYear] = useState(new Date().getFullYear());

//   return (
//     <div className="container mt-4">

//       {/* Heading */}
//       <h3 className="text-center text-primary mb-4">
//         Salary Reports
//       </h3>

//       {/* Filters Row */}
//       <div className="row mb-3 g-3">
//         {/* Report Type */}
//         <div className="col-md-4">
//           <label className="form-label">Report Type</label>
//           <select
//             value={reportType}
//             onChange={(e) => setReportType(e.target.value)}
//             className="form-select form-select-sm"
//           >
//             <option value="">-- Select Report --</option>
//             <option value="salarySheet">Salary Sheet</option>
//             <option value="paymentSlip">Payment Slip</option>
//             <option value="headWise">HeadWise Sheet</option>
//           </select>
//         </div>

//         {/* Month */}
//         <div className="col-md-2">
//           <label className="form-label">Month</label>
//           <input
//             type="number"
//             placeholder="1-12"
//             value={month}
//             min="1"
//             max="12"
//             onChange={(e) => {
//               let value = e.target.value;
//               if (value === "" || (value >= 1 && value <= 12)) setMonth(value);
//             }}
//             className="form-control form-control-sm"
//           />
//         </div>

//         {/* Year */}
//         <div className="col-md-2">
//           <label className="form-label">Year</label>
//           <input
//             type="number"
//             value={year}
//             onChange={(e) => {
//               let value = e.target.value;
//               if (value.length <= 4) setYear(value);
//             }}
//             className="form-control form-control-sm"
//           />
//         </div>
//       </div>
//       <hr />
//       {/* Report Section */}
//       <div className="mt-3">
//         {reportType === "salarySheet" && (
//           <SalaryReportWithNamesMaster reportName={reportType} month={month} year={year} />
//         )}
//         {reportType === "paymentSlip" && (
//           <PaymentSlipReport reportName={reportType} month={month} year={year} />
//         )}
//         {reportType === "headWise" && (
//           <HeadwiseSalary reportName={reportType} month={month} year={year} />
//         )}
//       </div>
//     </div>
//   );
// }
